// Ingot: Shopify can serve cached pages, so an online sale strikethrough rendered in
// Liquid (snippets/online-sale.liquid) can outlive the sale. Once a sale's end time
// passes, swap back to the regular price so we never show a price the cart won't charge.
;(function () {
  function expireOnlineSales() {
    const now = Date.now() / 1000

    document.querySelectorAll('[data-online-sale-ends]').forEach((el) => {
      const ends = Number(el.dataset.onlineSaleEnds)
      if (!ends || ends > now) return

      el.removeAttribute('data-online-sale-ends')
      el.removeAttribute('data-on-sale')
      el.querySelectorAll('[data-online-sale-only]').forEach((child) => child.remove())
      el.querySelectorAll('[data-online-sale-regular]').forEach((child) => child.style.removeProperty('display'))
    })
  }

  // Searchanise renders search results from its own product index, so the Liquid above
  // never sees them. Look up each result's online sale (templates/product.online-sale.liquid)
  // and rebuild its price in Searchanise's own sale markup.
  const saleRequests = {}

  function fetchOnlineSale(handle) {
    if (!saleRequests[handle]) {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'
      saleRequests[handle] = fetch(root + 'products/' + handle + '?view=online-sale')
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null)
    }
    return saleRequests[handle]
  }

  function applySearchaniseSale(priceList, sale) {
    priceList.querySelectorAll(':scope > *').forEach((child) => {
      child.style.display = 'none'
      child.setAttribute('data-online-sale-regular', '')
    })

    const price = document.createElement('span')
    price.className = 'snize-price snize-price-with-discount money'
    price.textContent = sale.price

    const label = document.createElement('span')
    label.className = 'snize-visually-hidden'
    label.textContent = 'Old price'

    const compareAt = document.createElement('span')
    compareAt.className = 'snize-discounted-price money'
    compareAt.textContent = sale.compare_at_price

    ;[price, label, compareAt].forEach((el) => {
      el.setAttribute('data-online-sale-only', '')
      priceList.appendChild(el)
    })

    if (sale.ends) priceList.setAttribute('data-online-sale-ends', sale.ends)
  }

  function updateSearchaniseResults() {
    document.querySelectorAll('.snize-price-list:not([data-online-sale-checked])').forEach((priceList) => {
      priceList.setAttribute('data-online-sale-checked', '')

      const link = priceList.closest('a[href*="/products/"]')
      const handle = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/)
      if (!handle) return

      fetchOnlineSale(handle[1]).then((sale) => {
        if (sale && priceList.isConnected) applySearchaniseSale(priceList, sale)
      })
    })
  }

  let searchaniseQueued = false
  new MutationObserver(() => {
    if (searchaniseQueued) return
    searchaniseQueued = true
    requestAnimationFrame(() => {
      searchaniseQueued = false
      updateSearchaniseResults()
    })
  }).observe(document.documentElement, { childList: true, subtree: true })

  expireOnlineSales()
  document.addEventListener('DOMContentLoaded', expireOnlineSales)
  setInterval(expireOnlineSales, 30000)
})()
